import { render, staticRenderFns } from "./AddContentToUserGroup.vue?vue&type=template&id=605e1451&scoped=true&lang=html&"
import script from "./AddContentToUserGroup.vue?vue&type=script&lang=js&"
export * from "./AddContentToUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddContentToUserGroup.vue?vue&type=style&index=0&id=605e1451&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e1451",
  null
  
)

export default component.exports